import Loader from "../../components/common/Loader";
import { optimizeCloudinaryImage } from "../../utils/cloudinary";

const LOADER_LOGO = optimizeCloudinaryImage(
  "https://res.cloudinary.com/dxwyw4yfk/image/upload/v1770775429/MochIcon_qlg3di.png",
  { width: 96, height: 96, crop: "fill" }
);

const RouteLoader = () => {
  return (
    <div className="min-h-screen app-page-bg flex items-center justify-center px-4">
      <div className="w-full max-w-sm rounded-2xl border border-border-soft bg-bg-card p-6 shadow-soft">
        <div className="flex flex-col items-center gap-3">
          <img
            src={LOADER_LOGO}
            alt="Mochi Donuts"
            className="h-12 w-12 rounded-full border border-border-soft object-cover"
          />
          <Loader className="h-6 w-6 text-brand" />
          <p className="text-sm font-medium tracking-[0.01em] text-text-body">
            Loading...
          </p>
        </div>
      </div>
    </div>
  );
};

export default RouteLoader;
